<template>
  <div class="register">
    <div style="margin-top: 50px">
      <h1 v-if="show" style="color: #1c1c36; font-size: 17px">
        {{ $t("register.title") }}
      </h1>
      <h1 v-else style="color: #1c1c36; font-size: 17px">
        {{ $t("register.passTitle") }}
      </h1>
    </div>

    <div v-if="show" style="margin-top: 40px">
      <van-field
        v-model="username"
        name=""
        label=""
        :placeholder="$t('register.username')"
        style="
          width: 80%;
          margin: 0 auto;
          border: 1px solid #eee;
          border-radius: 10px;
          margin-bottom: 10px;
        "
      />
    </div>

    <div v-else style="margin-top: 40px">
      <van-field
        v-model="password"
        type="password"
        name=""
        label=""
        :placeholder="$t('register.username')"
        style="
          width: 80%;
          margin: 0 auto;
          border: 1px solid #eee;
          border-radius: 10px;
          margin-bottom: 10px;
        "
      />
    </div>

    <div v-if="show" style="margin: 20px">
      <van-button
        class="button-background"
        style="width: 90%; margin: 0 auto; border: 1px solid #eee; color: #fff"
        round
        block
        plain
        type=""
        native-type=""
        @click="nextClick"
        >{{ $t("register.step") }}</van-button
      >
    </div>

    <div v-else style="margin: 20px">
      <van-button
        class="button-background"
        style="width: 90%; margin: 0 auto; border: 1px solid #eee; color: #fff"
        round
        block
        plain
        type=""
        native-type=""
        @click="register"
        :disabled="registerButton"
        >{{ $t("register.register") }}</van-button
      >
    </div>
  </div>
</template>

<script>
import { login } from "@/common/api/api";

export default {
  name: "register",
  data() {
    return {
      username: "",
      password: "",
      status: "register",
      show: true,
      registerButton: false,
    };
  },
  methods: {
    nextClick() {
      if (this.username == "" || !this.validateString(this.username)) {
        console.log(this.validateString(this.username));
        this.$toast.fail({
          duration: 5000,
          message: "Please enter 6-20 letters, numbers or combinations",
        });
        return;
      } else {
        this.show = false;
      }
    },
    register() {
      if (this.password == "" || !this.validateString(this.password)) {
        this.$toast.fail({
          duration: 5000,
          message: "Please enter 6-20 letters, numbers or combinations",
        });
        return;
      }
      this.registerButton = true;
      login(this.username.trim(), this.password.trim(), this.status)
        .then((res) => {
          if (res.code == 20010) {
            this.$toast.fail({
              duration: 5000,
              message: "The user already exists, please change the username",
            });
            this.username = "";
            this.password = "";
            this.$router.push("/login");
          } else {
            this.$toast.success({
              duration: 5000,
              message: "Registration successful"
            })
            localStorage.setItem(res.data.tokenName, res.data.tokenValue);
            this.$router.push("/");
          }
          setTimeout(()=> {
            this.registerButton = false;
            console.log(this.registerButton)
          }, 10000)
        })
        .catch(() => {
          this.registerButton = false;
        });
    },
    validateString(str) {
      const regex = /^[a-zA-Z0-9]{6,20}$/;
      return regex.test(str);
    },
  },
};
</script>

<style>
.button-background {
  background-image: linear-gradient(90deg, #d4b38f 0%, #b88964 100%) !important;
}
</style>
